import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

export const getCostCenterTypes = async () => {
    try {
        const response = await axios.get(`${base}/Accounts/GetCostCenterTypes`);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch cost centre types';
    }
};

export const getAllFinancialYears = async () => {
    try {
        const response = await axios.get(`${base}/Accounts/GetAllFinancialYears`);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch financial years';
    }
};

export const getCCS = async ({ ApplicableCCTypes, Roleid, UID, CCStatus }) => {
    try {
        const response = await axios.get(`${base}/Reports/GetCCS`, { params: { ApplicableCCTypes, Roleid, UID, CCStatus } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch cost centres';
    }
};

export const getConsolidateCashflowReportGrid = async ({ CCCode, StartYear, EndYear, PrevYear, CCtypes, Roleid, UID, CCStatus }) => {
    try {
        const response = await axios.get(`${base}/Reports/GetConsolidateCashflowReportGrid`, {
            params: { CCCode, StartYear, EndYear, PrevYear, CCtypes, Roleid, UID, CCStatus },
        });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch consolidate cashflow report';
    }
};

export const getConsolidateCashflowReportDetail = async ({ DCACode, CCCode, Year1, Year2, CCType, CCStatus }) => {
    try {
        const response = await axios.get(`${base}/Reports/GetConsolidateCashflowReportDetail`, {
            params: { DCACode, CCCode, Year1, Year2, CCType, CCStatus },
        });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch cashflow detail';
    }
};

export const getConsolidateInvoiceReceiptDetailViewReportGrid = async ({ CCCode, FYyear, Type, ReportType, CCtype, Searchtype }) => {
    try {
        const response = await axios.get(`${base}/Reports/ConsolidateInvoiceReceiptDetailViewReportGrid`, {
            params: { CCCode, FYyear, Type, ReportType, CCtype, Searchtype },
        });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch invoice/receipt detail';
    }
};
